import Companies from './Companies';
import companiesStore, { CompaniesStore } from './redux';

export { companiesStore };
export type { CompaniesStore };
export default Companies;
